import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import MensagemSucesso from "../../../../components/MensagemSucesso";
import MensagemErro from "../../../../components/MensagemErro";
import {
  atualizaFiltro,
  buscarRelatoriosPorCodigo,
  trazFiltrosPorIdFiltro,
} from "../../../../services/api-relatorios.service";
import Colunas from "../../../../components/BotaoRelatorio/components/Colunas";
import { ExportRelatorioContext } from "../../../../components/BotaoRelatorio/ExportRelatorioContext";
import Filtros from "../../../../components/BotaoRelatorio/components/Filtros";
import Empresas from "../../../../components/BotaoRelatorio/components/Empresas";
import { buscarGrupoEconomicoPorSchema } from "../../../../services/auth.service";
import FiltrosDinamicos from "../../../../components/BotaoRelatorio/components/FiltrosDinamicos";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import Loading from "../../../../components/Loading";

const EditFilterBtn = ({ idFiltro, codRelatorio, refreshFilters }) => {
  const [modal, setModal] = useState();
  const [snackBar, setSnackBar] = useState({
    error: false,
    success: false,
    msg: "",
  });
  const [relatorio, setRelatorio] = useState({
    nome: "",
    colunas: [],
    filtros: [],
  });
  const {
    setColunas,
    setFiltros,
    handleClose,
    setEmpresas,
    empresas,
    valoresFiltros,
    colunas,
    setValoresFiltros,
    setIdFiltroSavoContasContabeis,
    setApuracao,
  } = useContext(ExportRelatorioContext);
  const [nomeRelatorio, setNomeRelatorio] = useState("");
  const [hasSchema, setHasSchema] = useState(false);
  const [grupoEconomico, setGrupoEconomico] = useState({});
  const responsivUI = useMediaQuery("(min-width: 770px)");
  const [idRelatorio, setIdRelatorio] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const responseRelatorio = await buscarRelatoriosPorCodigo(codRelatorio);
        const responseFiltro = await trazFiltrosPorIdFiltro(idFiltro);
        const verificaSchema =
          responseRelatorio.relatorios[0].script.includes("${schema}");

        setIdRelatorio(responseRelatorio.relatorios[0].idRelatorio);

        setHasSchema(verificaSchema);

        if (verificaSchema) {
          if (responseFiltro.filtro.detalhes.schemas) {
            const responseGrupo = await buscarGrupoEconomicoPorSchema(
              responseFiltro.filtro.detalhes.schemas[0]
            );

            setGrupoEconomico(responseGrupo.grupo ?? null);
            setEmpresas(
              responseFiltro.filtro.detalhes.schemas.map((item) => ({
                id: item.replace(/[^\d]/g, ""),
                detalhes: item.replace(/[^\d]/g, ""),
              }))
            );
          }
        }

        setColunas(responseFiltro.filtro.detalhes.colunas);
        setFiltros(responseFiltro.filtro.detalhes.filtros ?? []);
        setValoresFiltros(responseFiltro.filtro.detalhes.filtros ?? []);
        setNomeRelatorio(responseFiltro.filtro.nomeDoFiltro);
        setRelatorio(responseRelatorio.relatorios[0]);
        setApuracao(responseRelatorio.relatorios[0].apuracao ?? false);

        const existContasContabeis =
          responseFiltro.filtro.detalhes.filtros.filter(
            (item) => (
              item.variavel === "$F{contas_contabil}" || 
              item.variavel === "$F{contas_contabeis}"
            )
          );

        if (existContasContabeis.length > 0) {
          const valueContasContabeis = existContasContabeis.map((item) =>
            item.valor
          );

          const idContasContabeis = valueContasContabeis[0].map((item) =>
            item.replace(/'/g, "")
          );

          setIdFiltroSavoContasContabeis(idContasContabeis);
        }

        setLoading(false);
      } catch (error) {
        handleSnackBar("error", error.response);
      }
    };

    modal && fetchData();
  }, [idFiltro, modal]);

  //#region ------- Handles

  const handleSnackBar = (type, msg = "") => {
    switch (type) {
      case "error":
        setSnackBar({ success: false, error: true, msg });
        break;

      case "success":
        setSnackBar({ success: true, error: false, msg });
        break;

      case "close":
        setSnackBar({ error: false, success: false, msg: "" });
        break;
    }
  };

  const handleModal = () => {
    modal && handleClose();
    setModal(!modal);
  };

  const handleChange = (e) => {
    const value = e.target.value;

    function formatString(input) {
      const cleanedInput = input.replace(/[^a-zA-Z0-9\s]/g, "");

      const titleCaseString = cleanedInput
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      return titleCaseString;
    }

    setNomeRelatorio(formatString(value));
  };

  const handleSubmit = async () => {
    let newSchemas = null;
    if (hasSchema && empresas.length > 0) {
      newSchemas = empresas.map((item) => {
        return `z_${item.id}`;
      });
    }

    const newFiltros =
      valoresFiltros.length > 0
        ? valoresFiltros.map((item) => {
            // Encontrar todos os parâmetros no script do filtro
            const parametros = item.script?.match(/\$P\{[^}]*\}/g) || [];

            // Gerar valores correspondentes para cada parâmetro (ajuste conforme necessário)
            const valores = parametros.map((param) => {
              const findFiltro = valoresFiltros
                .filter((item) => item.script.includes(param))
                .map((filtro) => {
                  return filtro.valor;
                });
              return findFiltro;
            });
            return {
              ...item,
              parametros, // Array de parâmetros
              valores: valores[0], // Array de valores correspondentes
            };
          })
        : null;

    const body = {
      nomeDoFiltro: nomeRelatorio,
      detalhes: {
        idRelatorio: idRelatorio,
        colunas: colunas?.length > 0 ? colunas : null,
        filtros: newFiltros,
        schemas: newSchemas,
      },
    };

    try {
      const response = await atualizaFiltro(idFiltro, body);
      refreshFilters();
      handleModal();
      handleSnackBar("success", response.mensagem);
    } catch (error) {
      handleSnackBar("error", error.response.data.mensagem);
    }
  };

  //#region ---- Styles

  const styleButton = {
    border: "1px solid #18316E",
    borderRadius: "20px",
    color: "#18316E",
    "&:hover": {
      backgroundColor: "#d0daf5",
    },
  };

  const submitButtonStyle = {
    borderRadius: "4px",
    minWidth: "180px",
    color: "#fff",
    backgroundColor: "#18316E",
    transition: "transform 100ms ease-in-out",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#18316E",
      transform: "scale(1.02)",
    },
  };

  const cancelButtonStyle = {
    border: "1px solid #18316E",
    borderRadius: "4px",
    minWidth: "180px",
    color: "#18316E",
    backgroundColor: "#fff",
    transition: "transform 100ms ease-in-out",
    "&:hover": {
      transform: "scale(1.02)",
    },
  };

  const containerBtnStyled = {
    padding: "15px",
    width: "100%",
    display: "flex",
    gap: "15px",
    flexDirection: responsivUI ? "row" : "column-reverse",
    justifyContent: "space-between",
  };

  const containerLoading = {
    width: "100%",
    alignItems: "center",
    display: "flex",
    height: "10rem",
    justifyContent: "center",
  };

  return (
    <>
      <Button
        startIcon={<BorderColorIcon />}
        sx={styleButton}
        onClick={handleModal}
      >
        EDITAR
      </Button>
      <Dialog open={modal} onClose={handleModal} fullWidth maxWidth="md">
        <DialogTitle>Editar Filtro</DialogTitle>

        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: "15px" }}
        >
          {loading ? (
            <Loading loading={loading} />
          ) : (
            <>
              <TextField
                label="Nome do Filtro"
                fullWidth
                name="nomeDoFiltro"
                value={nomeRelatorio}
                onChange={handleChange}
                size="small"
                sx={{ marginTop: "10px" }}
              />
              {relatorio?.colunas?.length > 0 && (
                <Colunas options={relatorio.colunas} />
              )}
              <Filtros options={relatorio.filtros} />
              {hasSchema && <Empresas grupo={grupoEconomico} />}
              <FiltrosDinamicos />
            </>
          )}
        </DialogContent>

        <DialogActions>
          <div style={containerBtnStyled}>
            <Button
              startIcon={<CloseIcon />}
              size="medium"
              sx={cancelButtonStyle}
              onClick={handleModal}
              fullWidth={responsivUI ? false : true}
            >
              Cancelar
            </Button>
            <Button
              startIcon={<SaveIcon />}
              size="medium"
              sx={submitButtonStyle}
              onClick={handleSubmit}
              fullWidth={responsivUI ? false : true}
            >
              Salvar
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={snackBar.success}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />

      <MensagemErro
        open={snackBar.error}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />
    </>
  );
};
export default EditFilterBtn;
